import moment from "moment";
import { timeLineSection } from "../constants";
import { User } from "views/settings-users/types";
import { TaskCreatedBy, WorkflowCreator, Subject } from "../types";
import { LinkableText } from "./LinkableText";

const isWorkflowCreator = (
  createdBy: TaskCreatedBy | null | undefined
): createdBy is WorkflowCreator => {
  return createdBy !== null && createdBy !== undefined && "type" in createdBy;
};

type TimelineSectionProps = {
  createdAt?: string;
  updatedAt?: string | null;
  completedAt?: string | null;
  assignees: User[];
  completedBy?: User | null;
  createdBy?: TaskCreatedBy | null;
  subject?: Subject | null;
};

export const TimelineSection = ({
  createdAt,
  updatedAt,
  completedAt,
  completedBy,
  createdBy,
  assignees,
  subject
}: TimelineSectionProps) => {
  const createdAtDisplay = createdAt
    ? moment(createdAt).format("MMM D, YYYY [at] h:mm A")
    : "-";
  const updatedAtDisplay =
    updatedAt && updatedAt !== "-"
      ? moment(updatedAt).format("MMM D, YYYY [at] h:mm A")
      : "-";
  const completedAtDisplay =
    completedAt && completedAt !== "-"
      ? moment(completedAt).format("MMM D, YYYY [at] h:mm A")
      : "-";
  const completedByName = completedBy?.id
    ? assignees.find((u: any) => u.id === completedBy.id)?.name || "-"
    : "-";

  const isWorkflow = isWorkflowCreator(createdBy);

  const getCreatedByDisplay = (): string => {
    if (isWorkflow) {
      if (createdBy.name) return `Workflow - ${createdBy.name}`;
      return "Workflow";
    }
    return createdBy?.name || "-";
  };

  const createdByDisplay = getCreatedByDisplay();

  const getSubjectLinkTo = () => {
    if (!subject) return undefined;
    if (subject.type === "boom_screen_applications")
      return `/applications/${subject.id}`;
    return `/leads/${subject.id}`;
  };

  const timelineFields = [
    { label: timeLineSection.updated_at, value: updatedAtDisplay },
    { label: timeLineSection.completed_at, value: completedAtDisplay },
    { label: timeLineSection.completed_by, value: completedByName },
    { label: timeLineSection.created_at, value: createdAtDisplay },
    {
      label: timeLineSection.created_by,
      content: createdByDisplay !== "-" ? createdByDisplay : undefined,
      linkTo: createdBy && isWorkflow ? `/workflows/${createdBy.id}` : undefined
    },
    {
      label: timeLineSection.link,
      content: subject?.name || subject?.property.name,
      linkTo: getSubjectLinkTo()
    }
  ];

  return (
    <div className="space-y-2">
      {timelineFields.map((field) => (
        <div key={field.label} className="flex items-center gap-2">
          <div className="min-w-[120px]">
            <span className="text-sm text-content-400">{field.label}</span>
          </div>
          {"content" in field || "linkTo" in field ? (
            <LinkableText content={field.content} linkTo={field.linkTo} />
          ) : (
            <span className="text-sm font-medium text-content-1000 flex-1">
              {field.value && field.value !== "-" ? field.value : "-"}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};
